import React from "react";
import CreateNewRoleForm from "../../components/AdminTabs/AdminChangePassword/CreateNewRoleForm";

const CreateNewRoleFormPage = () => {
  return (
    <div>
      <CreateNewRoleForm />
    </div>
  );
};

export default CreateNewRoleFormPage;
